// @flow

import DEFAULT_I18N from '../config/i18n';

import type { Player$Translation } from '../types/Translation';

export default function $t(i18n: ?$Shape<Player$Translation> = {}, key: $Keys<Player$Translation>): string {
   const val: ?string = i18n ? i18n[key] : null;
   return val || DEFAULT_I18N[key];
}
